export const LOCAL_STORAGE_PLANNING_ITEMS_KEY = 'planningItemsByEquipment';
